<template>
    <div>
        <div class="crumbs" hidden="true" style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 分销管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>等级配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover"  class="searchCard" >
            <div class='circleNumDiv'>
                <p class='circleNumP'>
                    <span class='circle1'>{{workData.waitNum1}}</span>
                </p>
                <p class='circleNumP'>
                    <span class='circle1'>{{workData.checkNum1}}</span>
                </p>
            </div>

            <span class="label-span">
                <label class="label">投诉时间</label>
                <el-date-picker v-model="query.startTime" value-format='yyyy-MM-dd' placeholder="开始日期" style="width:130px;"> </el-date-picker>
                <el-date-picker v-model="query.endTime" value-format='yyyy-MM-dd' placeholder="结束日期" style="width:130px;" class="mr10"> </el-date-picker>
            </span>
            <span class="label-span">
                    <label class="label">涉及业务</label>
                    <el-select v-model="query.goodsCode"  placeholder="涉及业务" clearable class="handle-input mr10">
                        <el-option v-for="item in select.option"  :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </span>
            <span class="label-span">
                    <label class="label">投诉类型</label>
                    <el-select v-model="query.tsId"  placeholder="投诉类型" clearable class="handle-input mr10">
                        <el-option key="item.id" label="全部" value="" />
                        <el-option v-for="item in select2.option"  :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </span>
            <span class="label-span">
                    <label class="label">工单等级</label>
                    <el-select v-model="query.level"  placeholder="投诉类型" clearable class="handle-input mr10">
                        <el-option key="item.id" label="全部" value="" />
                        <el-option key="item.id" label="常规" value="1" />
                        <el-option key="item.id" label="紧急" value="2" />
                    </el-select>
                </span>

            <span class="label-span">
                    <label class="label">办理号码</label>
                <el-input v-model.trim="query.phone" placeholder="办理号码"  class="handle-input mr10"></el-input>
                </span>
            <span class="label-span">
                    <label class="label">投诉地市</label>
                <el-input v-model.trim="query.city" placeholder="投诉地市"  class="handle-input mr10"></el-input>
                </span>
            <el-button type="success" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button type="error" icon="el-icon-refresh"  @click="refreshSearch">重置</el-button>
            <el-button  type="primary" size="small" icon="el-icon-lx-add" @click="addBind" >工单录入</el-button>
        </el-card>
        <el-card  shadow="hover"  class="containCard" >
            <el-table :data="tableData" border size="small" class="table"  ref="multipleTable" header-cell-class-name="table-header"   >
                <el-table-column prop="id" width="70" align="center" label="ID"></el-table-column>
                <el-table-column prop="woType" min-width="90" align="left" label="投诉类型">
                    <template slot-scope="scope">
                        <span v-for="item in select2.option" v-if='scope.row.tsId==item.optKey'>{{item.optVal}}</span>

                    </template>
                </el-table-column>
                <el-table-column prop="phone" width="230" align="left" label="办理号码">
                    <template slot-scope="scope">
                        <p class='size12'>
                            办理号码：<el-link type='primary' @click='copyText(scope.row.phone)'>{{scope.row.phone}}</el-link>
                                <el-tag style='margin-left:10px' type='info'>{{scope.row.city}}</el-tag><br>
                            联系号码：<el-link type='primary' @click='copyText(scope.row.phone2)'>{{scope.row.phone2}}</el-link>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" min-width="90" align="center" label="工单等级">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.level==2?'danger':'primary'">{{scope.row.level==2?'紧急':'常规'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="status" min-width="90" align="center" label="工单状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status==1?'info':scope.row.status==-1?'danger':'-'">{{scope.row.status==1?'待处理':scope.row.status==-1?'已拒绝':'-'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="goodsCode" min-width="180" align="left" label="涉及业务">
                    <template slot-scope="scope">
                    <el-link @click='copyText(scope.row.tsContent)' style='font-size:12px;' v-for="item in select.option" v-if='scope.row.goodsCode==item.optKey'>{{item.optVal}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="tsContent" min-width="260" align="left" label="投诉内容">
                    <template slot-scope="scope">
                        <div v-if="scope.row.tsContent!=null && scope.row.tsContent!=''">
                            <el-popover  placement="bottom" title="投诉内容"  width="600" trigger="hover" :content="scope.row.tsContent">
                                <el-link slot="reference" @click='copyText(scope.row.tsContent)' style='font-size:12px;line-height: 20px;webkit-line-clamp: 2;-webkit-box-orient: vertical;display: -webkit-box;overflow:hidden;text-overflow: ellipsis;'>{{scope.row.tsContent}}</el-link>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="tsDay" min-width="120" align="center"  label="投诉时间"> </el-table-column>
                <el-table-column prop="orderTime" min-width="160" align="center"  label="订购时间"> </el-table-column>
                <el-table-column prop="createTime" min-width="160" align="center"  label="工单时间"> </el-table-column>
                <el-table-column label="操作" min-width="110" align="center"  fixed="right">
                    <template slot-scope="scope" >
                        <span v-if='scope.row.status==1' class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑工单</span>
                        <span v-if='scope.row.status==-1' class='tableOperBtn' @click="handleEdit2(scope.$index, scope.row)" ><i class='el-icon-lx-calendar'></i> 处理记录</span><br>
                        <span v-if='scope.row.status==1' class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-lx-roundclose'></i> 撤销工单</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </el-card>
        <!-- 新建绑定弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="工单录入" :modal-append-to-body='false' :visible.sync="addVisible" top='50px' width='600px'    >
            <el-form ref="form1" :model="form1" label-width="90px" v-loading='addLoading'>
                <el-form-item required label="工单内容">
                    <el-input type="textarea" placeholder="请填写工单内容" :rows="5" v-model.trim="form1.content" ></el-input>
                </el-form-item>
                <el-button class='tsShibie' @click='tsShibie'>内容识别</el-button><br><br>
                <el-form-item required label="投诉类型" >
                    <el-radio-group v-model.trim="form1.tsId" >
                        <el-radio-button v-for="item in select2.option" :label="item.optKey">{{ item.optVal }}</el-radio-button>
                    </el-radio-group> 
                </el-form-item>
                <el-form-item required label="工单等级"  class='wid50' >
                    <el-radio-group v-model.trim="form1.level" >
                        <el-radio-button label="1">常规</el-radio-button>
                        <el-radio-button label="2">紧急</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item required label="办理号码"  class='wid50' >
                    <el-input oninput="value=value.replace(/[^\d]/g,'')" @change='overlength' v-model.trim="form1.phone" placeholder=""></el-input>
                </el-form-item>
                <el-form-item required label="所在地市"  class='wid50' >
                    <el-input v-model.trim="form1.city" placeholder="号码归属地"></el-input>
                </el-form-item>
                <el-form-item required label="联系号码"  class='wid50' >
                    <el-input oninput="value=value.replace(/[^\d]/g,'')" @change='overlength' v-model.trim="form1.phone2" placeholder=""></el-input>
                </el-form-item>

                <el-form-item required label="投诉时间" class='wid50'>
                    <el-date-picker v-model="form1.tsDay" :picker-options="pickerOptions1" value-format='yyyy-MM-dd' placeholder="投诉时间" style="width:100%;"> </el-date-picker>
                </el-form-item>
                <el-form-item required label="订购时间" class='wid50'>
                    <el-date-picker v-model="form1.orderTime" value-format='yyyy-MM-dd HH:mm:ss' type="datetime"  placeholder="订购时间" style="width:100%;"> </el-date-picker>
                </el-form-item>
                <el-form-item required label="涉及业务">
                    <el-select v-model="form1.goodsCode"  placeholder="办理业务" clearable class="wid100">
                        <el-option v-for="item in select.option"  :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog :close-on-click-modal="false" title="工单编辑" :modal-append-to-body='false' :visible.sync="editVisible"  width='600px'  >
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item required label="工单内容">
                    <el-input type="textarea" placeholder="请填写工单内容" :rows="5" v-model.trim="form.content" ></el-input>
                </el-form-item>
                <el-button class='tsShibie' @click='tsShibie'>内容识别</el-button><br><br>
                <el-form-item required label="投诉类型" >
                    <el-radio-group v-model.trim="form.tsId" >
                        <el-radio-button v-for="item in select2.option" :label="item.optKey">{{ item.optVal }}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item required label="工单等级"  class='wid50' >
                    <el-radio-group v-model.trim="form.level" >
                        <el-radio-button label="1">常规</el-radio-button>
                        <el-radio-button label="2">紧急</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item required label="办理号码"  class='wid50' >
                    <el-input oninput="value=value.replace(/[^\d]/g,'')" @change='overlength' v-model.trim="form.phone" placeholder=""></el-input>
                </el-form-item>
                <el-form-item required label="所在地市"  class='wid50' >
                    <el-input v-model.trim="form.city" placeholder="号码归属地"></el-input>
                </el-form-item>
                <el-form-item required label="联系号码"  class='wid50' >
                    <el-input oninput="value=value.replace(/[^\d]/g,'')" @change='overlength' v-model.trim="form.phone2" placeholder=""></el-input>
                </el-form-item>

                <el-form-item required label="投诉时间" class='wid50'>
                    <el-date-picker v-model="form.tsDay" :picker-options="pickerOptions1" value-format='yyyy-MM-dd' placeholder="投诉时间" style="width:100%;"> </el-date-picker>
                </el-form-item>
                <el-form-item required label="订购时间" class='wid50'>
                    <el-date-picker v-model="form.orderTime" value-format='yyyy-MM-dd HH:mm:ss' type="datetime"  placeholder="订购时间" style="width:100%;"> </el-date-picker>
                </el-form-item>
                <el-form-item required label="涉及业务">
                    <el-select v-model="form.goodsCode"  placeholder="办理业务" clearable class="wid100">
                        <el-option v-for="item in select.option"  :key="item.id" :label="item.optVal" :value="item.optKey" />
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer"  class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="处理记录" :modal-append-to-body='false' :visible.sync="editVisible2"  width='560px'  >
            <div  >
                <el-timeline style='margin-left:10px;'>
                    <el-timeline-item
                        v-for="(item, index) in replyList"
                        :key="index" >
                        <el-tag>{{item.status==1?'工单创建':item.status==2?'工单处理':item.status==-1?'审批拒接':item.status==9?'工单完结':'-'}}</el-tag>
                        <span v-if='item.status==2'><el-tag type='danger' class='ml10'>{{item.isCash==0?'仅退订':item.isCash==1?'已退费':'-'}}<b v-if='item.isCash==1' > - ￥{{item.cash}}</b></el-tag></span>
                        <span class='ml10' style='color:#777'>{{item.createTime}}</span>
                        <br>
                        <div class='ml10 mt5' v-if="item.content!=null && item.content!=''">
                            <el-link v-if='item.status==1' style='font-size:12px;line-height: 20px;'>工单内容：{{item.content}}</el-link>
                            <el-link v-if='item.status==2'  style='font-size:12px;line-height: 20px;'>
                                处理方案：{{item.content}}
                                <p v-if=' item.imgs!=null '>
                                    <img  v-for='url in item.imgs.split(",")' @click='seeImg(url)' :src='url' style='margin-right:10px;width:60px;height:90px'   />
                                </p>
                            </el-link>

                            <el-link v-if='item.status==-1 || item.status==9'  style='font-size:12px;line-height: 20px;'>
                                审批说明：{{item.content}}
                            </el-link>

                        </div>

                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-dialog>
        <el-dialog :modal-append-to-body='false' title="处理凭证"  :visible.sync="dialogVisible" width="550px" top="50px">
            <img width="100%" :src="dialogImageUrl" alt="" style="width:500px">
        </el-dialog>
    </div>
</template>

<script>
import { fetchData,
    saveForm,
    handDelete,
    saveEdit,
    getReplayList,
    getStateDetail,tsShibie,
    fetchDataAll,
    getWorkOrderShow2 as getWorkOrderShow
} from './woHandle';
import {fetchSelect3 as fetchSelect } from '../../api/comGoods';
import {fetchSelect as fetchSelect2} from '../../api/tsType';
import Bus from '../../components/common/bus';
import { fetchSelect as fetchSelect1 } from '@/api/comGoodsDoc';
import { changeStatus } from '@/api/goodsFrom';
export default {
    name: 'memGrade',
    data() {
        return {
            replyList:[],
            replyName:'回复',
            stationLogo:'',
            stationName:'',
            avatar:'',
            username:'',
            select:{option:'',},
            select2:{option:'',},
            query: {
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible:false,
            pageTotal: 0,
            form: {
            },
            form1: {  
                goodsCode:'',
                orderTime:'',
                phone:'',
                phone2:'',
                content:'',
                tsId:'',
                city:'',
                tsDay:'',
                level:'1',
            },
            form2: {  },
            workData:{},
            editVisible2:false,
            dialogVisible:false,
            addLoading:false,
            dialogImageUrl:'',
            idx: -1,
            id: -1,
            pickerOptions1: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        var nowDate = new Date();
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day);
                        picker.$emit('pick', dayDate1);
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 24);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day);
                        picker.$emit('pick', dayDate1);

                    }
                },{
                    text: '2天前',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 48);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day);
                        picker.$emit('pick', dayDate1);
                    }
                },{
                    text: '3天前',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 72);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day);
                        picker.$emit('pick', dayDate1);
                    }
                },{
                    text: '4天前',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 96);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day);
                        picker.$emit('pick', dayDate1);
                    }
                },{
                    text: '5天前',
                    onClick(picker) {
                        const nowDate = new Date();
                        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 120);
                        var date = {
                            year: nowDate.getFullYear(),
                            month: nowDate.getMonth(),
                            day: nowDate.getDate()
                        };
                        if(date.month==0){
                            date.month = 12;
                            date.year =  date.year - 1;
                        }else{
                            date.month = date.month +1;
                        }
                        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day);
                        picker.$emit('pick', dayDate1);
                    }
                }]
            },
        };
    },
    created() {
         
    }, 
    //页面加载方法
    mounted() {
        this.getSelect();
        this.getSelect2();
        this.getData();
        this.getWorkOrderShow();
    },
    methods: {
        getWorkOrderShow(){
            getWorkOrderShow({ }).then(res => {
                if(res.code=='200'){
                    this.workData = res.data;
                }
            });
        },
        copyText(text){
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);
            //提示已复制
            this.$message.success("内容已复制");
        },
        getSelect(){
            this.select = {};
            this.select.channelCode = '46';
            fetchSelect(this.select).then(res => {
                if(res.code=='200'){
                    this.$set(this.select, 'option', res.data);
                }
            });
        },
        getSelect2(){
            this.select2 = {};
            fetchSelect2(this.select2).then(res => {
                if(res.code=='200'){
                    this.$set(this.select2, 'option', res.data);
                }
            });
        },

        overlength(){
            if(this.form1.phone.length>11){
                this.$message.error("办理号码不超过11位");
            }
            if(this.form1.phone.length<11){
                this.$message.error("办理号码不少于11位");
            }
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        //刷新
        refresh(){
            history.go(0); 
        },
        //重置
        //重置按钮
        refreshSearch(){
            this.$set(this.query, 'startTime');
            this.$set(this.query, 'endTime');
            this.$set(this.query, 'goodsCode');
            this.$set(this.query, 'tsId');
            this.$set(this.query, 'phone');
            this.$set(this.query, 'city');
            this.$set(this.query, 'level');
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
            //清空下拉框   
        }, 
        //查询 
        getData(){
            this.query.status='1,-1';
            fetchData(this.query).then(res => {
                if(res.code=='200'){
                    this.getWorkOrderShow();
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
            });
        },
        // 关闭订单
        handDelete(index, row) {
            this.$confirm("确定要撤销此工单吗？", '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){
                        this.$message.success('撤销成功');
                        this.getData();
                        Bus.$emit("getData");
                    }else if(res.code=='201'){
                        this.$message.error("撤销异常："+res.message);
                    }
                });
            }).catch(() => {});

        },
        // 多选操作
       
        // 新增绑定
        addBind() {
            this.$set(this.form1, 'goodsCode', '');
            this.$set(this.form1, 'orderTime', '');
            this.$set(this.form1, 'phone', '');
            this.$set(this.form1, 'content', '');
            this.$set(this.form1, 'tsId', '');
            this.$set(this.form1, 'city', '');
            this.$set(this.form1, 'tsDay', '');
            this.$set(this.form1, 'phone2', '');
            this.addVisible = true;
        },
        tsShibie(){
            this.addLoading = true;
            this.$set(this.form1, 'goodsCode', '');
            this.$set(this.form1, 'orderTime', '');
            this.$set(this.form1, 'phone', '');
            this.$set(this.form1, 'tsId', '');
            this.$set(this.form1, 'city', '');
            this.$set(this.form1, 'tsDay', '');
            this.$set(this.form1, 'phone2', '');
            tsShibie(this.form1).then(res => {
                this.addLoading = false;
                if(res.code=='200'){
                    this.form1.tsDay = res.data.tsDay;
                    this.form1.goodsCode = res.data.goodsCode;
                    this.form1.phone = res.data.phone;
                    this.form1.phone2 = res.data.phone2;
                    this.form1.orderTime = res.data.orderTime;
                    this.form1.city = res.data.city;
                    this.$message.success(res.message);
                }else if(res.code=='201'){
                    this.$message({ type: 'warning',message:res.message,showClose:true,duration:10000 });
                    this.form1.tsDay = res.data.tsDay;
                    this.form1.goodsCode = res.data.goodsCode;
                    this.form1.phone = res.data.phone;
                    this.form1.phone2 = res.data.phone2;
                    this.form1.orderTime = res.data.orderTime;
                    this.form1.city = res.data.city;

                }else{
                    this.$message.error(res.message);
                }
            });
        },
        //保存新增
        saveForm() {
            if( !this.form1.content){
                this.$message.error("请填写工单内容");
                return;
            }
            if( !this.form1.tsId){
                this.$message.error("请选择投诉类型");
                return;
            }
            if( !this.form1.level){
                this.$message.error("请选择工单等级");
                return;
            }
            if( !this.form1.phone ){
                this.$message.error("请填写办理号码");
                return;
            }if( this.form1.phone.length!=11 ){
                this.$message.error("办理号码不正确，必须等于11位");
                return;
            }
            if( !this.form1.phone2 ){
                this.$message.error("请填写联系号码");
                return;
            }if( this.form1.phone2.length!=11 ){
                this.$message.error("联系号码不正确，必须等于11位");
                return;
            }
            if( !this.form1.tsDay){
                this.$message.error("请选择投诉时间");
                return;
            }
            if( !this.form1.orderTime){
                this.$message.error("请选择订购时间");
                return;
            }
            this.addVisible = false;
            saveForm(this.form1).then(res => {

                if(res.code=='200'){ 
                    this.$message.success(res.message);
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.form = row;
            this.editVisible = true;
        },
        handleEdit2(index, row) {
            let data = {};
            data.sid = row.id;
            getStateDetail(data).then(res => {
                if(res.code=='200'){
                    this.form2 = row;
                    this.replyList = res.data;
                    this.editVisible2 = true;
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        seeImg(url) {
            this.dialogImageUrl = url;
            this.dialogVisible = true;
        },
        // 保存编辑
        saveEdit() {
            if( !this.form.tsId){
                this.$message.error("请选择投诉类型");
                return;
            }
            
            if( !this.form.phone ){
                this.$message.error("请选择办理号码");
                return;
            }if( this.form.phone.length!=11 ){
                this.$message.error("办理号码不正确，必须等于11位");
                return;
            }
            if( !this.form.tsDay){
                this.$message.error("请选择投诉时间");
                return;
            }
            if( !this.form.goodsCode){
                this.$message.error("请选择投诉业务");
                return;
            }
            if( !this.form.tsContent){
                this.$message.error("请填写工单内容");
                return;
            }
            this.editVisible = false;
            saveEdit(this.form).then(res => {
                if(res.code=='200'){ 
                    this.getData();
                    this.$message.success("回复成功");  
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>


<style>
.tsShibie{
    position:fixed;
    background: #da3e55 !important;
    top:150px;
    margin-left:90px;
    margin-top:60px;
    z-index:100;
}
@media screen and (max-width:999px){ 
    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 10px;
    }
    .el-dialog,.el-dialog--center{
        width:315px;
    }
     .el-dialog__header {
        padding: 10px 10px 0px;
    }
    .btnCss{
       height:40px;
       margin-left:10px; 
    }
    .handle-del {
        float:left; 
        margin-top:10px;
        margin-left:10px; 
        margin-right:10px;  
    }
} 
@media screen and (min-width:999px){ 
    .el-dialog--center .el-dialog__body {
        text-align: initial;
        padding: 25px 25px 30px;
    }
     .el-dialog__header {
        padding: 20px 20px 0px;
    }
    
    .el-dialog,.el-dialog--center{
        width:560px;
    }
    .btnCss{
        
        display:inline-block;
    }
    .handle-del {
        float:right; 
    }
} 

 

.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
} 
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
